/*!

=========================================================
* Vision UI Free React - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/vision-ui-free-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com/)
* Licensed under MIT (https://github.com/creativetimofficial/vision-ui-free-react/blob/master LICENSE.md)

* Design and Coded by Simmmple & Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

import borders from "assets/theme/base/borders";
import pxToRem from "assets/theme/functions/pxToRem";

const { borderRadius } = borders;

export default {
  styleOverrides: {
    root: {
      display: "flex !important",
      width: "100% !important",
      padding: `${pxToRem(8)} ${pxToRem(12)} !important`,
      backgroundColor: "#0b1437 !important",
      border: "1px solid rgba(255, 255, 255, 0.22) !important",
      borderRadius: `${borderRadius.md} !important`,
      color: "#ffffff !important",

      "& fieldset": {
        border: "none !important",
      },
      "&.Mui-focused": {
        borderColor: "#0075ff !important",
      },
    },

    input: {
      height: "auto !important",
      width: "100% !important",
      color: "#ffffff !important",
      backgroundColor: "transparent !important",

      "&::placeholder": {
        color: "rgba(255, 255, 255, 0.5) !important",
        opacity: "1 !important",
      },
      "&::-webkit-input-placeholder": {
        color: "rgba(255, 255, 255, 0.5) !important",
      },
    },

    inputSizeSmall: {
      height: "auto !important",
    },
  },
};
